import React from 'react';
import {ThemeProvider} from '@material-ui/core/styles';
import {CssBaseline, Container} from '@material-ui/core';
import {MuiPickersUtilsProvider} from '@material-ui/pickers';
import UserProvider from './components/common/UserProvider';
import DateUtils from '@date-io/date-fns';
import Main from './components/Main';
import HdaeAppBar from './components/common/HdaeAppBar';
import HdaeFooter from './components/common/HdaeFooter';
import theme from './components/common/HdaeTheme';

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <UserProvider>
        <MuiPickersUtilsProvider utils={DateUtils}>
          <CssBaseline />
          <HdaeAppBar maxWidth="xl" title="DigiKnow Ad Requests" />
          <Container maxWidth="xl"><Main /></Container>
          <HdaeFooter maxWidth="xl" />
        </MuiPickersUtilsProvider>
      </UserProvider>
    </ThemeProvider>
  );
}
export default App;
